export default __webpack_public_path__ + "static/media/method4.7fe0a803.png";